import { createContext, ReactElement, ReactNode, useState } from "react";
import { ISelected } from "../types";

interface IProps {
  children: ReactNode[] | ReactNode;
}

interface IReportContextData {
  selected: ISelected;
  setSelected: (selected: ISelected) => void;
}

const emptyContextData: IReportContextData = {
  selected: { productionID: null, productionMachineID: null },
  setSelected: (selected) => console.log(selected)
};

const ReportContext = createContext<IReportContextData>(emptyContextData);
const { Provider } = ReportContext;

const ProductionReportContext = ({ children }: IProps): ReactElement => {
  const [selected, setSelected] = useState<ISelected>({ productionID: null, productionMachineID: null });

  return (
    <Provider value={{ selected, setSelected }}>
      {children}
    </Provider>
  );
};

export { ProductionReportContext, ReportContext };
